module.exports = __webpack_public_path__ + "static/media/sweden.d46dbac2.svg";